import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useDisconnectMicrosoftEmailMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    isError,
  } = useMutation<unknown, Error, void>({
    mutationFn: () => api.delete('oauth/connection?platform=MICROSOFT&functionality=EMAIL_SEND'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['oauth', 'connection-status'] });
    },
  });

  const disconnect = async () => {
    await mutateAsync();
  };

  return {
    disconnect,
    isLoading,
    isError,
  };
};
